import React, { useEffect, useState } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Select from "react-select";
import { Input } from 'semantic-ui-react';
import { GetUser, GetAllUsers, UpdateUsers, getotp, validate_otp, save_password } from '../../../services/auth-service/authService';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';

import useEnhancedEffect from "@mui/material/utils/useEnhancedEffect";

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function ApprovelForm() {
    
    const [show, setShow] = useState(true);
    const [dropdownlist, setdropdownlist] = useState([]);
    const [isstatus, setisstatus] = useState(true);
    const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
    const [formData, setFormData] = useState({
        user_id:'',
        employee_no: '',
        name: '',
        username: '',
        
        email: '',
        mobile_number: '',
        designation: '',
        department: '',
        reporting_manager: '',
    });

    const [selectedEmployee, setSelectedEmployee] = useState(null);

    const getUsersData = (selectedOption) => {
        let payload = { 'id': selectedOption.value };
        var getFileUploadsList = GetUser();

        axios.post(getFileUploadsList[1], payload, getFileUploadsList[0])
            .then(
                response => {
                    console.log("get user data!!!", response);
                    // let response = response.json();
                    let userData = response.data;
                    const [user] = userData;
                    console.log('data', user.status);
                    let status = user.status;
                    if (status) {
                        setisstatus(false);
                    }
                    setFormData({
                        user_id: user.user_id || '',
                        employee_no: user.employee_no || '',
                        name: user.name || '',
                        username: user.username || '',
                        email: user.email || '',
                        mobile_number: user.mobile_number || '',
                        designation: user.designation || '',
                        department: user.department || '',
                        reporting_manager: user.reporting_manager || '',
                    });
                }
            ).catch(
                error => {
                    console.log("Error in store user data!!!", error);

                }
            );
    }

    const handleEmployeeSelect = (selectedOption) => {
        setSelectedEmployee(selectedOption);
        getUsersData(selectedOption);
    };

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };


    useEffect(() => {

        let payload = { 'hi': 'hi' };
        var getFileUploadsList = GetAllUsers();

        axios.get(getFileUploadsList[1], payload, getFileUploadsList[0])
            .then(
                response => {
                    console.log("get all user data!!!", response);
                    // let response = response.json();
                    let data1 = response.data;
                    let data = data1.data_out;
                    let names = [];
                    data.map((data) => {
                        let obj = {
                            value: data.user_id,
                            label: data.name
                        }
                        names.push(obj);
                    });
                    console.log('names', names);
                    // setTargetOptions(names);
                    setdropdownlist(names);
                }
            ).catch(
                error => {
                    console.log("Error in store user data!!!", error);

                }
            );

    }, []);


    const handleSubmit = (val) => {
        let payload = formData;
        payload['status'] = val;
        console.log('payload', payload);

    var getFileUploadsList = UpdateUsers();

    axios.post(getFileUploadsList[1],  payload, getFileUploadsList[0])
        .then(
            response => {
                console.log("updated user data!!!", response);         
                
            }
        ).catch(
            error => {
                console.log("Error in store user data!!!", error);
        
            }
        );
    };

    const handleSubmit1 = (val) => {
        let payload = formData;
        payload['is_active'] = val;
        console.log('payload', payload);

    var getFileUploadsList = UpdateUsers();

    axios.post(getFileUploadsList[1],  payload, getFileUploadsList[0])
        .then(
            response => {
                console.log("updated user data!!!", response);         
                
            }
        ).catch(
            error => {
                console.log("Error in store user data!!!", error);
        
            }
        );
    };

    const getotpinfo = () => {
        let payload = {
            'user_id': userCredentials["user_id"],
        };
        

    var getFileUploadsList = getotp();

    axios.post(getFileUploadsList[1],  payload, getFileUploadsList[0])
        .then(
            response => {
                console.log("updated user data!!!", response);         
                
            }
        ).catch(
            error => {
                console.log("Error in store user data!!!", error);
        
            }
        );
    };

    const validateotp = () => {
        let payload = {
            'otp': formData.otp,
            'user_id': userCredentials["user_id"],
        };
        

    var getFileUploadsList = validate_otp();

    axios.post(getFileUploadsList[1],  payload, getFileUploadsList[0])
        .then(
            response => {
                console.log("updated user data!!!", response);         
                setShow(false);
            }
        ).catch(
            error => {
                console.log("Error in store user data!!!", error);
        
            }
        );
    };
    
    useEffect(() =>{
        getotpinfo();
    }, []);

    const handlesave = () =>{
        validateotp();
    }

    const saveuserinfo = () => {
        let payload = {
            'password': formData.password,
            'new_password': formData.new_password,
            'confirm_password': formData.confirm_password,
            'user_id': userCredentials["user_id"],
        };
        
        console.log('payload', payload);
    var getFileUploadsList = save_password();

    axios.post(getFileUploadsList[1],  payload, getFileUploadsList[0])
        .then(
            response => {
                console.log("updated password data!!!", response);         
                setShow(false);
            }
        ).catch(
            error => {
                console.log("Error in store user data!!!", error);
        
            }
        );
    };

    const handlesave1 = () =>{
        saveuserinfo();
    }

    const handlereject = () =>{
        handleSubmit('rejected')
    }

    const resendotp = () =>{
        getotpinfo();
    }

    const handleClose = () => {
        
        setShow(false);
    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs" style={{backgroundColor: 'rgb(233, 232, 217);'}}>
                <CssBaseline />
                <Box
                    sx={{
                        
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Approvel Form
          </Typography> */}
                    <Box component="form" noValidate sx={{ mt: 3 }} style={{backgroundColor:'white', padding:'1em'}}>
                        <Grid container spacing={2}>
                            
                            <Grid item xs={12}>
                                <TextField
                                    autoComplete="given-name"
                                    name="password"
                                    required
                                    fullWidth
                                    id="password"
                                    label="password"
                                    autoFocus
                                    value={formData.password}
                                    onChange={handleFormChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    id="new_password"
                                    label="new_password"
                                    name="new_password"
                                    autoComplete="user-name"
                                    value={formData.new_password}
                                    onChange={handleFormChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField

                                    name="confirm_password"
                                    required
                                    fullWidth
                                    id="confirm_password"
                                    label="confirm_password"
                                    autoComplete="confirm_password"
                                    value={formData.confirm_password}
                                    onChange={handleFormChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                            
                            </Grid>
                               
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 3, mb: 2 }}
                                            onClick={handlesave1}
                                        >
                                            Save
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 3, mb: 2 }}
                                            onClick={handlereject}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </>
                            

                        </Grid>


                    </Box>
                </Box>

            </Container>
            <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
    
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <>
                <Input
                    required
                    fullWidth
                    id="otp"
                    type="number"
                    placeholder="Enter OTP number"
                    name="otp"
                    autoComplete="otp"
                    value={formData.otp}
                    onChange={handleFormChange}
                />
                <div className="row">
                    <div className="col-md-3 ">
                    <Button
                                            
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 3, mb: 2 }}
                                            onClick={handlesave}
                                        >
                                            Save
                                        </Button>
                    </div>
                    <div className="col-md-3">
                    <Button
                                            
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 3, mb: 2 }}
                                            onClick={resendotp}
                                        >
                                            Resend
                                        </Button>
                    </div>
                </div>
                </>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
        </ThemeProvider>
    );
}